import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

const OrderPage = () => {

    const { id } = useParams();

    const [product, setProduct] = useState(null);
    const [form, setForm] = useState({
        name: "",
        address: "",
        contact: ""
    });

    // ✅ Fetch product automatically
    useEffect(() => {
        axios.get(`https://purvi-backend.onrender.com/product/${id}`)
            .then(res => setProduct(res.data));
    }, [id]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const res = await axios.post("https://purvi-backend.onrender.com", {
            productId: id,
            name: form.name,
            address: form.address,
            contact: form.contact
        });

        alert("Order placed! Price: ₹" + res.data.price);
    };

    if (!product) return <h2>Loading...</h2>;

    return (
        <div style={{ padding: "20px" }}>

            {/* ✅ PRODUCT DETAILS */}
            <h2>{product.title}</h2>

            <img 
                src={product.url} 
                alt={product.title}
                style={{ width: "200px" }}
            />

            <h3 style={{ color: "green" }}>
                ₹{product.price}
            </h3>

            {/* ✅ ORDER FORM */}
            <form onSubmit={handleSubmit} style={{ marginTop: "20px" }}>

                <input
                    type="text"
                    placeholder="Your Name"
                    required
                    onChange={(e) => setForm({...form, name: e.target.value})}
                />

                <br /><br />

                <input
                    type="text"
                    placeholder="Address"
                    required
                    onChange={(e) => setForm({...form, address: e.target.value})}
                />

                <br /><br />

                <input
                    type="text"
                    placeholder="Contact Number"
                    required
                    onChange={(e) => setForm({...form, contact: e.target.value})}
                />

                <br /><br />

                <button type="submit">
                    Place Order
                </button>

            </form>
        </div>
    );
};

export default OrderPage;